module.exports = __webpack_public_path__ + "6141a3ba644dc1b5f06bfe5ea015bcd8.png";